import { ComponentChildren } from 'preact'
import styles from './index.module.css'
import { classnames } from '../../../utils'
import { useCallback } from 'preact/hooks'
import { useLongPress } from '../../../hooks'
import type { StorableBarcode } from '../../../store/BarcodeListStore'

export function BarcodeListItem({
  barcode,
  highlighted,
  onLongPress,
  onReleasePress,
}: {
  barcode: StorableBarcode
  highlighted: boolean
  onLongPress: (info: StorableBarcode) => void
  onReleasePress: (info: StorableBarcode) => void
}) {
  const _onLongPress = useCallback(
    (_: EventTarget) => {
      onLongPress(barcode)
    },
    [barcode, onLongPress]
  )

  const _onReleasePress = useCallback(
    (_: EventTarget) => {
      onReleasePress(barcode)
    },
    [barcode, onReleasePress]
  )
  const listeners = useLongPress(_onLongPress, _onReleasePress, 350)
  return (
    <li class={classnames({ [styles.highlighted]: highlighted })} {...listeners}>
      <div>
        <div class={styles.data}>{barcode.data}</div>
        <div class={styles.symbology}>{barcode.symbologyDescription.readableName}</div>
      </div>
      <div class={styles.quantity}>{barcode.quantity.value > 1 ? `Qty ${barcode.quantity.value}` : ''}</div>
    </li>
  )
}

export function BarcodeList({ children }: { children: ComponentChildren }) {
  return <ul class={styles.barcodeList}>{children}</ul>
}
